// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoFundsPlaceholder_wrapper__Hx5t-","text":"NoFundsPlaceholder_text__1f9r8"};